import axios from 'axios';

let prefix = "/user-voucher"

const UserVoucherApi = {
	
	getUserVoucherList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	createUserVoucher(payload){
		return axios.post( prefix + "/create", payload)
	},
	archiveUserVoucher(payload){
		return axios.delete( prefix + "/archive", {params: payload})
	},
	exportUserVoucherList(payload) {
		return axios.get(prefix + "/export-user-voucher", { params: payload })
	},
}

export default UserVoucherApi;